// extracted by mini-css-extract-plugin
export default {"axis":"Axis_axis__jpokI","cell":"Axis_cell__1RxbR"};